export const TAP_NATIVE_ALLOWED_PATHS = [
  '/resources/glp1-bridge/guide',
  '/resources/glp1-bridge/recording',
  '/resources/glp1-bridge/assistant',
];

export const UNSAFE_QUERY_KEYS = [
  'auth',
  'code',
  'dob',
  'dateofbirth',
  'date_of_birth',
  'email',
  'first',
  'firstname',
  'first_name',
  'last',
  'lastname',
  'last_name',
  'mbi',
  'medicare',
  'npi',
  'patient',
  'plan',
  'planid',
  'plan_id',
  'reset',
  'search',
  'session',
  'token',
  'uid',
  'user',
  'userid',
  'user_id',
  'zip',
];

const UNSAFE_STORAGE_KEY_PATTERN =
  /(auth|bearer|jwt|login|mbi|medicare|patient|phi|refresh|session|token|user)/i;
const SAFE_BROWSER_STATE_KEYS = new Set([
  'medhug_session_id',
  'medhug_tab_opened_at',
]);

const UNSAFE_VALUE_PATTERNS = [
  /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i,
  /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/,
  /\b[1-9][A-HJ-NP-Z][A-HJ-NP-Z0-9][0-9]-?[A-HJ-NP-Z][A-HJ-NP-Z0-9][0-9]-?[A-HJ-NP-Z][A-HJ-NP-Z0-9][0-9][0-9]\b/i,
  /\b(?:19|20)\d{2}[-/](?:0[1-9]|1[0-2])[-/](?:0[1-9]|[12]\d|3[01])\b/,
  /\b(?:0[1-9]|1[0-2])[-/](?:0[1-9]|[12]\d|3[01])[-/](?:19|20)\d{2}\b/,
];

function normalizePathname(pathname = '/') {
  if (!pathname) return '/';
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

function isAllowedPath(pathname) {
  const normalized = normalizePathname(pathname);
  return TAP_NATIVE_ALLOWED_PATHS.some((allowedPath) => normalized === normalizePathname(allowedPath));
}

function hasUnsafeQuery(search = '') {
  const params = new URLSearchParams(search);

  for (const [rawKey, rawValue] of params.entries()) {
    const key = rawKey.toLowerCase().replace(/[^a-z0-9_]/g, '');

    if (UNSAFE_QUERY_KEYS.some((unsafeKey) => key.includes(unsafeKey))) {
      return true;
    }

    if (UNSAFE_VALUE_PATTERNS.some((pattern) => pattern.test(rawValue))) {
      return true;
    }
  }

  return false;
}

function hasUnsafeBrowserState() {
  if (typeof window === 'undefined') return false;

  try {
    const storageAreas = [window.localStorage, window.sessionStorage].filter(Boolean);

    for (const storage of storageAreas) {
      for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (key && !SAFE_BROWSER_STATE_KEYS.has(key) && UNSAFE_STORAGE_KEY_PATTERN.test(key)) {
          return true;
        }
      }
    }
  } catch {
    return true;
  }

  try {
    return document.cookie
      .split(';')
      .map((cookie) => cookie.trim().split('=')[0])
      .some((name) => !SAFE_BROWSER_STATE_KEYS.has(name) && UNSAFE_STORAGE_KEY_PATTERN.test(name));
  } catch {
    return true;
  }
}

export function canLoadTapNative({
  pathname = typeof window !== 'undefined' ? window.location.pathname : '/',
  search = typeof window !== 'undefined' ? window.location.search : '',
  isAuthenticated = false,
  isHipaaMode = false,
  hasSensitiveBrowserState = hasUnsafeBrowserState(),
} = {}) {
  if (!isAllowedPath(pathname)) return false;
  if (isAuthenticated || isHipaaMode || hasSensitiveBrowserState) return false;
  if (hasUnsafeQuery(search)) return false;

  return true;
}

export function getSafeTapNativeUrl(location = typeof window !== 'undefined' ? window.location : null) {
  if (!location) return '';

  return `${location.origin}${normalizePathname(location.pathname)}`;
}
